import { Box, Flex, Text } from "@chakra-ui/react";

import { Percentage } from "@/api/accurate-types";
import { REPORT_BLOCK_INTERNAL_GAP } from "@/features/report/consts/sizes";
import { displayNumber } from "@/utils/get-display-number";

export const LegendPercentages = ({ percentages }: { percentages: Percentage[] }) => {
  return (
    <Box gap={REPORT_BLOCK_INTERNAL_GAP}>
      {percentages
        .sort((a, b) => b.percentage - a.percentage)
        .map((item) => (
          <Flex key={item.class}>
            <Box flexShrink={0} boxSize={4} bg={item.color} mr={2} />
            <Text>
              <Text as="strong">{displayNumber(item.percentage)}%</Text>: {item.label}
            </Text>
          </Flex>
        ))}
    </Box>
  );
};
